import type { VerifyContainer, VerifyState } from "~/store/verifySlice";

const readLastActivityAt = (container: VerifyContainer): string => container.lastScanAt ?? container.createdAt;

const keepLatestActivity = (kept: VerifyContainer | undefined, candidate: VerifyContainer): VerifyContainer =>
	kept && readLastActivityAt(kept) >= readLastActivityAt(candidate) ? kept : candidate;

const rekeyVerifyContainersById = (state: VerifyState): VerifyState => {
	const containers: Record<string, VerifyContainer> = {};
	for (const container of Object.values(state.containers)) {
		containers[container.containerId] = keepLatestActivity(containers[container.containerId], container);
	}
	return { ...state, containers };
};

export default rekeyVerifyContainersById;
